<script setup lang="ts">
/**
 * Full-row totals footer for the Finances table. Selected by
 * `DynamicTable.rowOverride` for the single synthetic totals row appended
 * after the client rows (mirrors `DateHeaderRowCell`'s pattern for
 * synthetic rows, but renders one plain `<td>` per column instead of a
 * single `colspan` cell, so each total lines up under its own column).
 *
 * All values arrive pre-formatted from `FinancesTab` — this component only
 * lays them out, matching `DateHeaderRowCell`'s "dumb renderer" role.
 */
defineProps<{
  row: {
    clientCountLabel: string
    columnTotals: number[]
    grandTotalRevenueFormatted: string
  }
  colspan?: number
}>()
</script>

<template>
  <td class="finance-totals-cell" />
  <td class="finance-totals-cell finance-totals-cell--label">{{ row.clientCountLabel }}</td>
  <td class="finance-totals-cell" />
  <td v-for="(total, i) in row.columnTotals" :key="i" class="finance-totals-cell">
    {{ total.toLocaleString() }}
  </td>
  <td class="finance-totals-cell finance-totals-cell--revenue">
    {{ row.grandTotalRevenueFormatted }}
  </td>
</template>

<style scoped>
.finance-totals-cell {
  font-family: var(--font-tufte-mono);
  font-weight: 600;
  text-align: center;
  border-top: 2px solid var(--color-tufte-text);
  background: color-mix(in srgb, var(--color-tufte-border) 15%, var(--color-tufte-bg));
}

.finance-totals-cell--label {
  font-family: var(--font-tufte-sans);
  text-align: left;
}

.finance-totals-cell--revenue {
  color: var(--color-money-positive);
}
</style>
